// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.F0f9EC2t1zogfcYk3jkA {
  max-height: 20rem;
}

.F0f9EC2t1zogfcYk3jkA::-webkit-scrollbar {
  width: .25rem;
}

.F0f9EC2t1zogfcYk3jkA::-webkit-scrollbar-track {
  background: transparent;
}

.F0f9EC2t1zogfcYk3jkA::-webkit-scrollbar-thumb {
  background-color: var(--gray-200);
  border-radius: var(--border-radius);
  border: 0;
}

.nwyLg6wam5awZEEobY60 {
  list-style: none;
  cursor: default;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

.nwyLg6wam5awZEEobY60:not(:first-of-type) {
  border-top: var(--component-border-width) solid var(--component-border-color);
}

.Z42OVgDlFhbb9mNhwFOs {
  font-size: 1.125rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/CommunityDetails/SchedulePostList/schedulePostList.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAiB;KAAjB,sBAAiB;MAAjB,qBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".box {\n  max-height: 20rem;\n}\n\n.box::-webkit-scrollbar {\n  width: .25rem;\n}\n\n.box::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.box::-webkit-scrollbar-thumb {\n  background-color: var(--gray-200);\n  border-radius: var(--border-radius);\n  border: 0;\n}\n\n.listItem {\n  list-style: none;\n  cursor: default;\n  user-select: none;\n}\n\n.listItem:not(:first-of-type) {\n  border-top: var(--component-border-width) solid var(--component-border-color);\n}\n\n.itemTitle {\n  font-size: 1.125rem;\n}"],"sourceRoot":""}]);
// Exports
export var box = `F0f9EC2t1zogfcYk3jkA`;
export var listItem = `nwyLg6wam5awZEEobY60`;
export var itemTitle = `Z42OVgDlFhbb9mNhwFOs`;
export default ___CSS_LOADER_EXPORT___;
